// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryClassPicker_wrapper__kop2m","secondaryItemLabel":"CategoryClassPicker_secondaryItemLabel__3F1l8","treeWrapper":"CategoryClassPicker_treeWrapper__3606v"};